<template>
    <div >
<!--        <el-container>-->

<!--            <el-container>-->
                <el-aside width="200px" :style="{'position':'absolute','display': 'flex','height':'100%'}">
                    <el-menu :default-openeds="['1', '3']">
                        <el-submenu index="1">
                            <template slot="title">Vue</template>
                            <el-menu-item-group>
                                <el-menu-item index="1-1"@click="aa('http://heiline.ltd/ademo/note/Vue.html')">详解</el-menu-item>
                                <el-menu-item index="1-2">选项2</el-menu-item>
                            </el-menu-item-group>

                        </el-submenu>

                    </el-menu>
                </el-aside>
<!--                <el-container :style="{'top': '0px','position':'relate','background-color': 'red'}">-->

<!--                    <el-main v-html>-->
<!--                        <html>-->
<!--&lt;!&ndash;                        <head>&ndash;&gt;-->
<!--&lt;!&ndash;                            <script type="text/javascript" src="http://bullj.com/ademo/bullj.js"></script>&ndash;&gt;-->
<!--&lt;!&ndash;                        </head>&ndash;&gt;-->
<!--                        <body class='typora-export os-windows'>-->
<!--                        <div>nihao</div>-->
<!--                        </body>-->
<!--                        </html>-->
                        <iframe :src="src" width="100%" height="590px" frameborder="0" scrolling="auto" id="iframename" name="iframename">
                        <meta http-equiv=”Content-Type” content=”text/html; charset=u″ />
                    </iframe>
<!--                    </el-main>-->

<!--                </el-container>-->
<!--            </el-container>-->
<!--        </el-container>-->
    </div>
</template>

<script>
    export default {
        name: "NoteP",
        data(){
            return{
                src:'http://heiline.ltd/ademo/note/Vue.html',
            }
        },
        methods:{
            aa(value){
                this.src=value;
            }
        }

    }
</script>

<style scoped>

</style>